import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Tag from './tag'

import styles from './tag-wrapper.module.css'

const propTypes = {
    className: PropTypes.string,
    numRemainingItems: PropTypes.number
}

function RemainingPlusTag({ className, numRemainingItems }) {
    const remainingTagClassname = cx(styles['remaining-plus-tag'], className, 't3sel-tag-wrapper-remaining-plus-tag')
    return <Tag className={remainingTagClassname}>{`+ ${numRemainingItems}`}</Tag>
}

RemainingPlusTag.propTypes = propTypes

export { RemainingPlusTag }
